function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "99.3639147%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#F0B537",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#FAC93D",
  offset: "65.7675253%"
}), React.createElement("stop", {
  stopColor: "#FAC93D",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "ICON-Favorited.Gold",
  fill: "url(#linearGradient-1)"
}, React.createElement("polygon", {
  id: "Star_Yellow",
  points: "15.2615263 7.30055146 11.6595263 -9.37916411e-13 8.0565263 7.30055146 4.47997195e-12 8.47114172 5.8295263 14.1535515 4.45354276 22.1777369 11.6595263 18.3895515 18.8655099 22.1777369 17.4885263 14.1535515 23.3190526 8.47114172"
})));

var SvgStarYellow = function SvgStarYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "star-yellow",
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStarYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star_yellow.49a59505.svg";
export { ForwardRef as ReactComponent };